import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PaymentReceiver } from "@app/shared/models/payment-receiver";
import { UriBuilderParams, BaseHttpService, Query } from "./base/base-http.service";
import { BackendUriUnits } from "./base/backend-uri-units";
import { HttpServiceBundle } from "./base/http-service-bundle.service";
import { DrQueryParams } from "./base/base-service-with-bundle.service";
import { BaseList } from "@app/shared/models/list";
import { map } from "rxjs/operators";

export class PaymentReceiverBuilderUriParams extends UriBuilderParams<PaymentReceiver> {
    
    constructor(paymentType?: PaymentReceiver | string) {
        super(paymentType);
    }

    public buildUri(): string {
        const uri = `/${BackendUriUnits.PAYMENT_RECEIVERS}`;
        return uri;
    }
}

@Injectable({
    providedIn: 'root'
})
export class PaymentReceiverService extends BaseHttpService<PaymentReceiver, PaymentReceiverBuilderUriParams>
                                    implements Query<PaymentReceiver, PaymentReceiverBuilderUriParams> {

    constructor(httpServiceBundle: HttpServiceBundle) {
        super(PaymentReceiver, httpServiceBundle);
    }

    public query(uriParams: PaymentReceiverBuilderUriParams, params?: DrQueryParams, propOverride?: string): Observable<BaseList<PaymentReceiver>> {
        return this.queryBase(uriParams, params);
    }

}